import PersonListing from './personListing';

const personListingConfig = {
  name: 'personListing',
  class: PersonListing,
  querySelectorAll: {
    dropdowns: '.dropdown',
  },
};

export default personListingConfig;
